export default __webpack_public_path__ + "32a66585ed19e11f157f94ddb26064d2.jpg";